import { useEffect } from 'react'

export const useDisableBodyScroll = (disabled: boolean) => {
  useEffect(() => {
    if (disabled) {
      document.body.classList.add('overflow-hidden')
    } else {
      document.body.classList.remove('overflow-hidden')
    }

    return () => {
      if (disabled) {
        document.body.classList.remove('overflow-hidden')
      }
    }
  }, [disabled])
}
